<div class="col-12">
  <form #f="ngForm" (ngSubmit)="save()">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-sm-6">
                <label for="nombre">Nombre</label>
                <input
                  #nombre="ngModel"
                  [(ngModel)]="escuela.nombre"
                  name="nombre"
                  type="text"
                  id="nombre"
                  required
                  placeholder="Nombre"
                  class="form-control"
                />
                <div
                  class="alert alert-danger"
                  *ngIf="nombre.touched && nombre.invalid"
                >
                  Nombre es requerido
                </div>
              </div>
              <div class="form-group col-sm-6">
                <label for="cuit">Cuit</label>
                <input
                  #cuit="ngModel"
                  [(ngModel)]="escuela.cuit"
                  name="cuit"
                  type="text"
                  class="form-control"
                  id="cuit"
                  required
                  placeholder="Cuit"
                />
                <div
                  class="alert alert-danger"
                  *ngIf="cuit.touched && cuit.invalid"
                >
                  Cuit es requerido
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-6">
                <label for="telefono1">Teléfono</label>
                <input
                  #telefono1="ngModel"
                  [(ngModel)]="escuela.telefono1"
                  name="telefono1"
                  class="form-control"
                  type="text"
                  id="telefono1"
                  required
                  placeholder="Teléfono"
                />
                <div
                  class="alert alert-danger"
                  *ngIf="telefono1.touched && telefono1.invalid"
                >
                  Teléfono es requerido
                </div>
              </div>
              <div class="form-group col-sm-6">
                <label for="telefono2">Teléfono Alternativo</label>
                <input
                  #telefono2="ngModel"
                  [(ngModel)]="escuela.telefono2"
                  name="telefono2"
                  class="form-control"
                  type="text"
                  id="telefono2"
                  required
                  placeholder="Teléfono Alternativo"
                />
                <div
                  class="alert alert-danger"
                  *ngIf="telefono2.touched && telefono2.invalid"
                >
                  Teléfono Alternativo es requerido
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12">
                <label for="direccion">Direccion</label>
                <input
                  #direccion="ngModel"
                  [(ngModel)]="escuela.direccion"
                  name="direccion"
                  class="form-control"
                  type="text"
                  placeholder="Direccion"
                  id="direccion"
                  required
                />
                <div
                  class="alert alert-danger"
                  *ngIf="direccion.touched && direccion.invalid"
                >
                  Direccion es requerido
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-6">
                <label for="dipregep">Dipregep</label>
                <input
                  placeholder="Dipregep"
                  [(ngModel)]="escuela.dipregep"
                  class="form-control"
                  name="dipregep"
                  type="text"
                  id="dipregep"
                />
              </div>
              <div class="form-group col-sm-6">
                <input
                  placeholder="Ingresos Brutos"
                  [(ngModel)]="escuela.ingresosBrutos"
                  class="form-control"
                  name="ingresosBrutos"
                  type="text"
                  id="ingresosBrutos"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-6">
                <label for="subencion1">Subención 1</label>
                <input
                  placeholder="Subención 1"
                  [(ngModel)]="escuela.subencion1"
                  name="subencion1"
                  type="text"
                  class="form-control"
                  id="subencion1"
                />
              </div>
              <div class="form-group col-sm-6">
                <label for="subencion2">Subención 2</label>
                <input
                  placeholder="Subención 2"
                  [(ngModel)]="escuela.subencion2"
                  class="form-control"
                  name="subencion2"
                  type="text"
                  id="subencion2"
                />
              </div>
            </div>

            <div class="row">
              <div class="form-group col-sm-12">
                <label for="titularColegio">Titular colegio</label>
                <input
                  placeholder="Titular colegio"
                  [(ngModel)]="escuela.titularColegio"
                  class="form-control"
                  name="titularColegio"
                  type="text"
                  id="titularColegio"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-6">
                <label for="puntoventa">Punto Venta afip</label>
                <input
                  placeholder="Punto Venta afip"
                  [(ngModel)]="escuela.puntoventa"
                  name="puntoventa"
                  type="text"
                  class="form-control"
                  id="puntoventa"
                />
              </div>
              <div class="form-group col-sm-6">
                <label for="fechaInscripcionAfip">Fecha Inscripción Afip</label>
                <input
                  placeholder="Fecha Inscripción Afip"
                  [(ngModel)]="escuela.fechaInscripcionAfip"
                  name="fechaInscripcionAfip"
                  class="form-control"
                  type="text"
                  id="fechaInscripcionAfip"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Avatar</h4>
            <h6 class="card-subtitle">Imagen de la Escuela</h6>

            <div class="text-center">
              <img
                *ngIf="!imgTemp"
                [src]="escuela.imageUrl"
                class="img-avatar"
              />
              <img *ngIf="imgTemp" [src]="imgTemp" class="img-avatar" />
            </div>

            <input
              type="file"
              (change)="cambiarImagen($event.target.files[0])"
            />

            <br />
            <div class="text-left">
              <button
                type="submit"
                class="btn btn-success waves-effect waves-light m-r-10"
                (click)="subirImagen()"
                [disabled]="!subirImagen"
              >
                Cambiar imagen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="action-buttons">
    <button type="button" class="btn btn-primary mr-2" (click)="save()">
      Guardar
    </button>
    <button type="button" class="btn btn-danger mr-2" (click)="delete()">
      Eliminar
    </button>
    <button type="button" class="btn btn-warning mr-2" (click)="volver()">
      Volver
    </button>
  </div>
</div>
